import { useEffect, useState } from "react";
import { Company } from "../../core/models/company.model";
import CompanyCard from "../CompanyCard/CompanyCard";
import CompanyAddressInfo from "../CompanyCard/CompanyCardInfo/CompanyAddressInfo";
import CompanyPhoneInfo from "../CompanyCard/CompanyCardInfo/CompanyPhoneInfo";
import CompanyWebLinkInfo from "../CompanyCard/CompanyCardInfo/CompanyWebLinkInfo";

interface ModalCompanyInfoProps {
  company: Company | undefined;
};

const ModalCompanyInfo = (props: ModalCompanyInfoProps) => {
  const [company, setPropValue1] = useState(props.company);

  useEffect(() => {
    setPropValue1(props.company);
  }, [props.company]);


  return (
    <div className='modal-company-container w-md-100'>
      <div className="modal-company-header">
        <CompanyCard company={company} isDetailsCard={true} />
      </div>
      <div className="modal-company-info d-flex flex-column ">
        <CompanyAddressInfo company={company}/>
        <CompanyPhoneInfo company={company} />
        <CompanyWebLinkInfo company={company} />
      </div>
    </div>
  );
}

export default ModalCompanyInfo;